module.exports = __webpack_public_path__ + "img/menu.4c4b3884.svg";